export enum PhysicalActivityStatuses {
    SEDENTRY = 'Sedentary',
    INSUFFICIENTLY_ACTIVE = 'Insufficiently Active',
    ACTIVE = 'Active',
    HIGHLY_ACTIVE = 'Very Active',
  }
